import {
  ORIGINATOR_HEADER,
  ORIGINATOR_VERSION_HEADER,
} from './originatorHeaders';

export function toPlainHeaders(headers) {
  if (!headers) {
    return {};
  }

  if (typeof headers.toJSON === 'function') {
    return headers.toJSON();
  }

  return { ...headers };
}

export function stripAuthenticatedRequestHeaders(headers) {
  const plainHeaders = toPlainHeaders(headers);

  delete plainHeaders.Authorization;
  delete plainHeaders[ORIGINATOR_HEADER];
  delete plainHeaders[ORIGINATOR_VERSION_HEADER];

  return plainHeaders;
}
